import React, { useEffect, useRef, useState } from 'react'
import { animate } from 'motion/react'

/**
 * Плавный count-up числового значения.
 * При изменении value число «докручивается» от старого значения к новому.
 * Используется для баланса и других «живых» цифр.
 *
 * Props:
 * - value: number — целевое значение
 * - duration: number — длительность анимации в секундах (по умолчанию 0.6)
 */
const AnimatedNumber = ({ value, duration = 0.6 }) => {
  const [display, setDisplay] = useState(value)
  const prevRef = useRef(value)

  useEffect(() => {
    const from = prevRef.current
    prevRef.current = value
    if (from === value) return

    const controls = animate(from, value, {
      duration,
      ease: 'easeOut',
      onUpdate: (latest) => setDisplay(Math.round(latest))
    })
    return () => controls.stop()
  }, [value, duration])

  return <>{display.toLocaleString()}</>
}

export default AnimatedNumber
